import { alternaleaf, BrandThemeProvider } from '@montugroup/themes';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import AltLogo from '@montugroup/circuit-shared/components/common/AltLogo';

import { IconButton } from '@montugroup/design-system';
import { PartnerContainer } from './PortalPartner.styles';

const AlternaleafLogoWithSx = styled(AltLogo)({});

const ParentHeaderContainer = styled(PartnerContainer)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

function ParentHeader() {
  const navigate = useNavigate();

  return (
    <ParentHeaderContainer>
      <BrandThemeProvider theme={alternaleaf}>
        <IconButton
          disableRipple
          size="small"
          sx={{
            padding: 0,
            '&.MuiButtonBase-root:focus': {
              outline: 'none',
            },
            marginLeft: '-0.75rem',
          }}
          onClick={() => navigate({ pathname: '/home' }, { state: { destinationPortal: 'patient' } })}
          aria-label="Return to Alternaleaf"
        >
          <ChevronLeft color="primary" fontSize="large" sx={{ marginRight: 2 }} />
          <AlternaleafLogoWithSx
            fillColor="currentColor"
            sx={{ color: (theme) => theme.palette.primary.main }}
            width="150"
          />
        </IconButton>
      </BrandThemeProvider>
    </ParentHeaderContainer>
  );
}

export default ParentHeader;
